<template>
    <div class="upload-cadre">
        <div class="upload-content row" @dragover="dragover" @dragleave="dragleave" @drop="drop" @dragenter="dragenter">
            <div class="div-Dowload">
                <v-img v-if="hasFile || uploadedFile" src="@/assets/download-icon.png" class="upload-image" />
                <v-img v-else src="@/assets/upload-icon.png" class="upload-image" />
                <a v-if="showDownload" class="browse-file" @click="fnDownload">{{ $t("actions.download") }}</a>
            </div>
            <div v-if="showUpload" style="width: 80%; padding: 0px; margin-bottom: 10px; margin-top:10px;">
                <div class="upload-title">
                    <span>{{ $t('upload.drag') }}<a class="browse-file" @click="chooseFiles()">{{ $t('upload.browse')
                    }}</a></span>
                    <a style="text-decoration: none;position: relative; display: inline-block;" v-if="showGenerate"
                        class="browse-file" @click="emitGenerateEvent">{{ $t('upload.generate') }}
                        <v-progress-linear v-if="userGenerateLoader" indeterminate color="cyan"
                            class="progress-underline"></v-progress-linear>
                    </a>
                </div>
                <div class="upload-sub-title">{{ $t(subTitle) }}</div>
                <div v-if="subTitle2" class="upload-sub-title">{{ $t(subTitle2) }}</div>
            </div>
        </div>
    </div>
    <input type="file" name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
        class="w-px h-px opacity-0 overflow-hidden absolute d-none" @change="onChange" ref="file" :accept="fileTypes"  />
    <v-file-input v-model="DocumentUrl" :accept="fileTypes" id="fileUpload" style="visibility: hidden; display: none;"
        :key="fileInputKey"></v-file-input>
    <slot name="DocumentsList"></slot>
    <div v-if="afficheSucces" class="updateSuccess"
        :style="afficheTrue ? 'background-color: #E8FFF1;' : 'background-color: #f0c0c0;'">
        <v-card-text class="text-center" :style="afficheTrue ? 'color: #24c581;' : 'color: #F25C5C;'">
            <p v-if="generationSuccess">{{ $t('document.generateSuccess') }}</p>
            <p v-else-if="this.afficheTrue">{{ $t('document.uploadSucces') }}</p>
            <p v-else-if="!(this.DocumentUrl.size / 1024 / 1024 < 25)">{{ $t('configuration.video.warningSize') }}</p>
            <p v-else>{{ $t('configuration.video.supportedTypes') }} {{fileTypes.map(fileType =>
                fileType.name).join(', ')}}</p>
        </v-card-text>
    </div>
    <v-snackbar v-model="afficheSucces" :timeout="2000" color="transparent" style="opacity: 0;">
    </v-snackbar>
</template>
<script>
export default {
    components: {},
    props: {
        namedocument: {},
        generationSuccess: {
            type: Boolean,
            default: false,
        },
        hasFile: {
            type: Boolean,
            default: false
        },
        userGenerateLoader: {
            type: Boolean,
            default: false
        },
        fnDownload: {
            default: null
        },
        showDownload: {
            type: Boolean,
            default: false
        },
        showUpload: {
            type: Boolean,
            default: false
        },
        showGenerate: {
            type: Boolean,
            default: false
        },
        fileTypes: {
            default: [
                { mimeType: "video/mp4", name: "MP4" },
                { mimeType: "video/webm", name: "WEBM" },
                { mimeType: "video/ogg", name: "OGG" }
            ]
        },
        subTitle: {
            default: 'configuration.video.FileMSG'
        },
        subTitle2: {
            default: null
        },
    },
    data: () => ({
        fileInputKey: Date.now(),
        snackbar: true,
        DocumentUrl: [],
        afficheSucces: false,
        afficheTrue: true,
        isLoaded: false,
        uploadedFile: false,
        isHovered: null,
        selectedIndex: null,
        showDeleteDialog: null,
        uploadedFileNames: [],
    }),
    watch: {
        DocumentUrl() {
            if (this.DocumentUrl) {
                this.afficheSucces = true
                if (this.fileTypes.some(fileType => fileType.mimeType === this.DocumentUrl.type) && this.DocumentUrl.size / 1024 / 1024 < 25) {
                    this.$emit('addVideo', this.DocumentUrl)
                    this.$emit('fileChange')
                    this.uploadedFile = true
                    this.afficheTrue = true
                } else {
                    this.afficheTrue = false
                }
            }
        },
        generationSuccess(newVal) {
            this.afficheSucces = newVal
        }
    },
    methods: {
        emitGenerateEvent() {
            this.fileInputKey = Date.now();
            this.$emit('generate');

        },
        chooseFiles: function () {
            document.getElementById("fileUpload").click()

        },
        dragover(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = this.$props.showUpload ? 'move' : 'none';
        },
        dragleave(event) {
            event.preventDefault();
        },
        dragenter(event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = this.$props.showUpload ? 'move' : 'none';
        },
        drop(event) {
            if (this.$props.showUpload) {
                event.preventDefault();
                this.$refs.file.files = event.dataTransfer.files;
                this.onChange();
            } else {
                event.preventDefault();
            }
        },
        onChange() {
            this.filelist = [...this.$refs.file.files];
            this.DocumentUrl = this.filelist
        },
    }
};
</script>
<style scoped>
.updateSuccess {
    height: 40px;
    border-radius: 6px;
    font-family: 'Inter';
}

.updateSuccess .v-card-text {
    font-weight: 600;
    font-size: 12px;
    line-height: 50%;
}

.upload-cadre {
    width: 100%;
    height: max-content;
    border-radius: 4px;
    border: 1px dashed rgba(56, 78, 183, 0.30);
    background: #F8F8FF;
    padding-left: 15px;
    padding-right: 15px;
}

.upload-cadre:hover {
    background: #ddd;
}

.upload-content {
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;
}

.upload-image {
    width: 70px;
    height: 60px;
}

.upload-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #0F0F0F;
    text-align: start;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 5px;
    width: 100%;
}

.upload-title span {
    display: flex;
    align-items: center;
}

.upload-title>a {
    margin-left: auto;
}


.browse-file {
    color: #3BBAFF;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-decoration-line: underline;
    cursor: pointer;
    padding-left: 4px;
}

.upload-sub-title {
    color: var(--grays-gray-500, #939EAA);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    text-align: start;
    margin-right: 5px;
}

.div-Dowload {
    width: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
}

.progress-underline {
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
}
</style>